export const s3bucket = "https://mindforce.s3.ap-south-1.amazonaws.com"